import { flow, applySnapshot } from 'mobx-state-tree';
import { getIdentifier, toMapById } from '~/mst/utils';
import api from '~/api';
import { IUsersModel } from './model';

export default (self: IUsersModel) => ({
  fetch: flow(function* fetch(params?, options?) {
    try {
      self.startFetching();
      const { data } = yield self.sync(api.users.fetch, params, options);
      applySnapshot(self.models, toMapById(data, 'id'));
      self.finishFetching();
    } catch (error) {
      self.failFetching(error);
    }
  }),
  remove(user) {
    self.models.delete(getIdentifier(user)!);
  }
});
